<template>
  <div class="memberCenter_wrap ChangeInform" :style="{ height: height }">
    <div class="nav_pos mb_nav_pos">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>
          <router-link to="/MemberCenter">首页</router-link>
        </el-breadcrumb-item>
        <el-breadcrumb-item>到货确认</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="change_inform">
      <div class="title">基本信息</div>
      <div>
        <el-form :inline="true" :model="contract" class="form_table form_table1" ref="form" :inline-message="true">
          <el-form-item label="甲方名称"
            ><span>{{ contract.CompanyName }}</span></el-form-item
          >
          <el-form-item label="甲方联系人"
            ><span>{{ contract.PartyAName }}</span></el-form-item
          >
          <el-form-item label="甲方联系人联系方式"
            ><span>{{ contract.PartyATel }}</span></el-form-item
          >

          <el-form-item label="合同编号"
            ><span>{{ contract.ContractNumber }}</span></el-form-item
          >
          <el-form-item label="合同货期起算方式"
            ><span>{{ contract.TranslateType }}</span></el-form-item
          >
          <el-form-item label="合同起算时间"
            ><span>{{ contract.AuditDate }}</span></el-form-item
          >

          <el-form-item label="合同总价（元）"
            ><span>{{ contract.ContractFee }}</span></el-form-item
          >
          <el-form-item label="发货前联系人"
            ><span>{{ contract.ShippingContact }}</span></el-form-item
          >
          <el-form-item label="发货前联系人联系方式"
            ><span>{{ contract.ShippingTel }}</span></el-form-item
          >
        </el-form>
      </div>
      <div class="title">
        设备清单
        <span style="color: orange">
          <i class="el-icon-warning">请勾选需要提交到货确认函的设备，并据实填写完整相关信息及上传附件资料</i>
        </span>
      </div>
      <el-row style="margin-top: 10px; margin-left: 15px">
        <el-col :span="3">
          <el-upload
            action="#"
            :before-remove="removeConfirm"
            :on-change="fileChange"
            :on-exceed="exceedFile"
            :on-success="handleSuccess"
            :on-error="handleError"
            :auto-upload="true"
            :data="{ name: 'ConfirmAttach' }"
            :http-request="batchUploadFile"
            ref="ConfirmAttach"
          >
            <el-button size="mini" type="primary" plain>批量上传到货确认函附件</el-button>
          </el-upload>
        </el-col>
        <el-col :span="2">
          <el-upload
            action="#"
            :before-remove="removeConfirm"
            :on-change="fileChange"
            :on-exceed="exceedFile"
            :on-success="handleSuccess"
            :on-error="handleError"
            :auto-upload="true"
            :data="{ name: 'ConfirmOtherAttach' }"
            :http-request="batchUploadFile"
            ref="ConfirmOtherAttach"
          >
            <el-button size="mini" type="primary" plain>批量上传其他附件</el-button>
          </el-upload>
        </el-col>
      </el-row>

      <el-form class="rule-form" style="overflow: auto; width: 100%; margin: 0" :inline="true" :inline-message="true">
        <table class="statistics_table">
          <tbody>
            <tr>
              <th width="80px">
                <el-checkbox v-model="allprojectListCheck"></el-checkbox>
              </th>
              <th width="120px">计划编号</th>
              <th width="120px">货物名称</th>
              <th width="120px">规格型号</th>
              <th width="120px">品牌</th>
              <th width="200px"><label class="start">*</label>品牌所属国家/地区</th>
              <th width="80px">数量</th>
              <th width="120px">总价</th>

              <th width="100px">货期（自然日）</th>
              <th width="120px">合同约定到货日期</th>
              <th width="250px"><label class="start">*</label>实际到货日期</th>
              <th width="120px">是否逾期</th>
              <th width="250px">预警到货天数（自然日）</th>
              <th width="250px">逾期/提前到货天数（自然日）</th>
              <th width="200px"><label class="start">*</label>实际设备到货地</th>
              <th width="120px">到货确认状态</th>
              <th width="350px"><label class="start">*</label>到货确认函附件</th>
              <th width="350px"><label class="start">*</label>说明书附件</th>
              <th width="350px">其他附件</th>
            </tr>
            <template v-for="(data, index) in projectList">
              <tr :key="index">
                <td>
                  <el-checkbox v-if="data.IsScelect == false" v-model="data.Check"></el-checkbox>
                </td>
                <td>{{ data.PlanCode }}</td>
                <td>{{ data.InstrumentName }}</td>
                <td>{{ data.Specification }}</td>
                <td>{{ data.Trademark }}</td>
                <td>
                  <span v-if="data.IsScelect">{{ data.BrandCountryName }}</span>
                  <el-select v-else v-model="data.BrandCountry" filterable placeholder="请选择品牌所属国家">
                    <el-option v-for="item in brandCountryList" :key="item.value" :label="item.text" :value="item.value"> </el-option>
                  </el-select>
                </td>
                <td>{{ data.Count }}</td>

                <td>{{ data.SumFee }}</td>
                <td>{{ data.DeliveryTerm }}</td>
                <td>{{ data.ArrivalDate }}</td>
                <td>
                  <span v-if="data.IsScelect">{{ data.ActualArrivalDate }}</span>
                  <el-date-picker
                    v-else
                    v-model="data.ActualArrivalDate"
                    type="date"
                    placeholder="实际到货日期"
                    value-format="yyyy-MM-dd"
                  ></el-date-picker>
                </td>
                <td>{{ data.IsOverTime }}</td>
                <td>{{ data.WarnDay }}</td>
                <td>{{ data.WarnDay1 }}</td>
                <td>
                  <span v-if="data.IsScelect">{{ data.ArrivalAddressName }}</span>
                  <el-cascader
                    v-else
                    placeholder="请选择实际设备到货地"
                    :options="arrivalAddressList"
                    v-model="data.ArrivalAddress"
                    filterable
                  ></el-cascader>
                </td>
                <td>{{ data.ArrivalConfirmState }}</td>
                <td>
                  <el-upload
                    v-if="!data.IsScelect"
                    :disabled="data.IsScelect"
                    action="#"
                    :before-remove="removeConfirm"
                    :on-change="fileChange"
                    :on-exceed="exceedFile"
                    :on-success="handleSuccess"
                    :on-error="handleError"
                    :auto-upload="true"
                    :file-list="data.ConfirmAttach"
                    :data="{ id: index, name: 'ConfirmAttach' }"
                    :http-request="uploadFile"
                    ref="uploader"
                    :on-remove="
                      (file, fileList) => {
                        handleRemove1(file, fileList, index)
                      }
                    "
                  >
                    <el-button size="mini" type="primary" plain>点击上传</el-button>
                  </el-upload>
                  <div v-else v-for="(item1, index1) in data.ConfirmAttach" :key="index1">
                    <el-link class="fileName" @click="fnDownload(item1.fileId)" :underline="false"> {{ item1.name }}</el-link>
                    <el-link @click="fnReadPdf(item1.fileId)" :underline="false" style="color: #0361b1; padding-left: 15px"> 预览</el-link>
                  </div>
                </td>
                <td>
                  <el-upload
                    v-if="!data.IsScelect"
                    action="#"
                    :before-remove="removeConfirm"
                    :on-change="fileChange"
                    :on-exceed="exceedFile"
                    :on-success="handleSuccess"
                    :on-error="handleError"
                    :auto-upload="true"
                    :file-list="data.ConfirmOtherAttach2"
                    :data="{ id: index, name: 'ConfirmOtherAttach2' }"
                    :http-request="uploadFile"
                    ref="uploader"
                    :on-remove="
                      (file, fileList) => {
                        handleRemove3(file, fileList, index)
                      }
                    "
                  >
                    <el-button size="mini" type="primary" plain>点击上传</el-button>
                  </el-upload>
                  <div v-else v-for="(item1, index1) in data.ConfirmOtherAttach2" :key="index1">
                    <el-link class="fileName" @click="fnDownload(item1.fileId)" :underline="false"> {{ item1.name }}</el-link>
                    <el-link @click="fnReadPdf(item1.fileId)" :underline="false" style="color: #0361b1; padding-left: 15px"> 预览</el-link>
                  </div>
                </td>
                <td>
                  <el-upload
                    v-if="!data.IsScelect"
                    action="#"
                    :before-remove="removeConfirm"
                    :on-change="fileChange"
                    :on-exceed="exceedFile"
                    :on-success="handleSuccess"
                    :on-error="handleError"
                    :auto-upload="true"
                    :file-list="data.ConfirmOtherAttach"
                    :data="{ id: index, name: 'ConfirmOtherAttach' }"
                    :http-request="uploadFile"
                    ref="uploader"
                    :on-remove="
                      (file, fileList) => {
                        handleRemove2(file, fileList, index)
                      }
                    "
                  >
                    <el-button size="mini" type="primary" plain>点击上传</el-button>
                  </el-upload>
                  <div v-else v-for="(item1, index1) in data.ConfirmOtherAttach" :key="index1">
                    <el-link class="fileName" @click="fnDownload(item1.fileId)" :underline="false"> {{ item1.name }}</el-link>
                    <el-link @click="fnReadPdf(item1.fileId)" :underline="false" style="color: #0361b1; padding-left: 15px"> 预览</el-link>
                  </div>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </el-form>

      <div class="btn_wrap changeInform_btn_wrap">
        <span class="btn_1" @click="fnGoBack()">返回</span>
        <span class="btn_1" @click="fnSave()">提交</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      uploadUrl: '',
      contractId: this.$route.query.contractId,
      projectIdList: this.$route.query.projectId,
      projectList: [],
      arrivalAddressList: [],
      height: '0px',
      allprojectListCheck: '',
      contract: {},
      brandCountryList: []
    }
  },
  watch: {
    allprojectListCheck(val) {
      this.projectList.forEach((element) => {
        if (element.hasOwnProperty('Check') && !element.IsScelect) {
          element.Check = val
        }
      })
    }
  },
  mounted() {
    let change_inform = document.getElementsByClassName('MemberHeader')[0]
    this.height = window.innerHeight - change_inform.clientHeight - 17 + 'px'
    this.getData()
  },
  methods: {
    getData() {
      let config = {
        params: {
          contractId: this.contractId
        }
      }
      this.getRequest('/Contract/GetArrivalConfirmData', config).then((res) => {
        if (res.data.errcode == 0) {
          this.contract = res.data.contract
          this.projectList = res.data.projectList
          this.arrivalAddressList = res.data.arrivalAddressList
          this.brandCountryList = res.data.brandCountryList
          let idList = this.projectIdList.split(',')
          this.projectList.forEach((item) => {
            idList.forEach((item1) => {
              if (item.RootProjectId == item1) {
                item.Check = true
              }
            })
          })
        } else {
          this.$message.error(res.data.errmsg)
        }
      })
    },
    fnGoBack() {
      window.close()
    },
    batchUploadFile(params) {
      var selectProjectList = this.projectList.filter((item) => {
        return item.Check == true
      })
      if (selectProjectList.length > 0) {
        console.log(params)
        let file = params.file
        var data = new window.FormData()
        let loginToken = window.localStorage.getItem('loginToken')
        data.append('file', params.file)
        data.append('loginToken', loginToken)
        this.uploadFileRequest('/Common/UploadFile', data).then((res) => {
          if (res.data.errcode == 0) {
            console.log(res.data)
            let obj = {
              fileId: res.data.FileList[0].id,
              name: res.data.FileList[0].fileName
            }
            if (params.data.name == 'ConfirmAttach') {
              selectProjectList.forEach((item) => {
                if (item.ConfirmAttach.length == 0) {
                  var fileList = [obj]
                  item.ConfirmAttach = fileList
                } else {
                  item.ConfirmAttach.push(file)
                }
              })
            } else if (params.data.name == 'ConfirmOtherAttach') {
              selectProjectList.forEach((item) => {
                if (item.ConfirmOtherAttach.length == 0) {
                  var fileList = [obj]
                  item.ConfirmOtherAttach = fileList
                } else {
                  item.ConfirmOtherAttach.push(file)
                }
              })
            }
          } else {
            this.$message.error(res.data.errmsg)
          }
        })
        console.log(this.projectList)
      } else {
        this.$message({
          showClose: true,
          message: `请先选择要批量上传附件的设备！`,
          type: 'warning'
        })
      }
      this.$refs[params.data.name].clearFiles()
    },
    uploadFile(params) {
      console.log(params)
      let file = params.file
      var data = new window.FormData()
      let loginToken = window.localStorage.getItem('loginToken')
      data.append('file', params.file)
      data.append('loginToken', loginToken)
      this.uploadFileRequest('/Common/UploadFile', data).then((res) => {
        if (res.data.errcode == 0) {
          console.log(res.data)
          let obj = {
            fileId: res.data.FileList[0].id,
            name: res.data.FileList[0].fileName
          }
          if (params.data.name == 'ConfirmAttach') {
            if (this.projectList[params.data.id].ConfirmAttach.length == 0) {
              var fileList = [obj]
              this.projectList[params.data.id].ConfirmAttach = fileList
            } else {
              this.projectList[params.data.id].ConfirmAttach.push(obj)
            }
          } else if (params.data.name == 'ConfirmOtherAttach') {
            if (this.projectList[params.data.id].ConfirmOtherAttach.length == 0) {
              var fileList = [obj]
              this.projectList[params.data.id].ConfirmOtherAttach = fileList
            } else {
              this.projectList[params.data.id].ConfirmOtherAttach.push(obj)
            }
          } else if (params.data.name == 'ConfirmOtherAttach2') {
            if (this.projectList[params.data.id].ConfirmOtherAttach2.length == 0) {
              var fileList = [obj]
              this.projectList[params.data.id].ConfirmOtherAttach2 = fileList
            } else {
              this.projectList[params.data.id].ConfirmOtherAttach2.push(obj)
            }
          }
        } else {
          this.$message.error(res.data.errmsg)
        }
      })
    },
    exceedFile(files, fileList) {
      this.$message({
        showClose: true,
        message: `最多上传100个文件`,
        type: 'warning'
      })
    },
    // 文件状态改变时的钩子
    fileChange(file, fileList) {},
    // 点击x时执行的钩子函数
    removeConfirm(file, fileList) {
      if (file.status == 'success') {
        return this.$confirm(`确定删除 ${file.name}？`)
      }
    },
    handleRemove1(file, fileList, index) {
      console.log(file, fileList, index)
      if (file.hasOwnProperty('fileId')) {
        this.postRequest('/Common/DeleteAttachmentByFileId', {
          fileId: file.fileId
        }).then((res) => {
          if (res.data.errcode == 0) {
            this.projectList[index].ConfirmAttach = this.projectList[index].ConfirmAttach.filter((item1) => {
              return item1.uid != file.uid
            })
          } else {
            this.$message.error(res.data.errmsg)
          }
        })
      }
      console.log(this.projectList)
    },
    handleRemove2(file, fileList, index) {
      if (file.hasOwnProperty('fileId')) {
        this.postRequest('/Common/DeleteAttachmentByFileId', {
          fileId: file.fileId
        }).then((res) => {
          if (res.data.errcode == 0) {
            this.projectList[index].ConfirmOtherAttach = this.projectList[index].ConfirmOtherAttach.filter((item1) => {
              return item1.uid != file.uid
            })
          } else {
            this.$message.error(res.data.errmsg)
          }
        })
      }
      console.log(this.projectList)
    },
    handleRemove3(file, fileList, index) {
      if (file.hasOwnProperty('fileId')) {
        this.postRequest('/Common/DeleteAttachmentByFileId', {
          fileId: file.fileId
        }).then((res) => {
          if (res.data.errcode == 0) {
            this.projectList[index].ConfirmOtherAttach2 = this.projectList[index].ConfirmOtherAttach2.filter((item1) => {
              return item1.uid != file.uid
            })
          } else {
            this.$message.error(res.data.errmsg)
          }
        })
      }
      console.log(this.projectList)
    },
    // 文件上传成功时的钩子
    handleSuccess(response, file, fileList) {
      if (response.errcode == 0) {
        this.fileList = fileList
        // this.fileIds.push(response.fileId);
        this.$notify.success({
          title: '上传结果',
          message: `${file.name}上传成功`,
          position: 'bottom-right'
        })
      } else {
        this.$notify.error({
          title: '上传结果',
          message: `${file.name}上传失败:${response.errmsg}`,
          position: 'bottom-right'
        })
      }
    },
    // 文件上传失败时的钩子
    handleError(err, file, fileList) {
      this.$notify.error({
        title: '上传结果',
        message: `${file.fileName}上传失败:{err}`,
        position: 'bottom-right'
      })
    },
    fnDownload(fileId) {
      let token = window.localStorage.getItem('loginToken')
      var url = '/Common/DownloadFile?FileId=' + fileId + '&token=' + token + '&FileName='
      this.downloadfile(this.baseURL + url)
    },
    fnReadPdf(fileId) {
      let routerData = this.$router.resolve({
        path: 'ReadPDF',
        query: {
          fileId: fileId
        }
      })
      window.open(routerData.href, '_blank')
    },
    fnSave() {
      let flag = true
      let that = this
      var selectProjectList = this.projectList.filter((item) => {
        return item.Check
      })
      if (selectProjectList.length == 0) {
        that.$message.error(`请选择要到货确认的设备`)
        flag = false
        return false
      }
      selectProjectList.forEach(function (instrument, index) {
        if (instrument.BrandCountry == '' || instrument.BrandCountry == null) {
          that.$message.error(`请填写${instrument.InstrumentName}的品牌所属国家/地区`)
          flag = false
          return false
        }
        if (instrument.ActualArrivalDate == '' || instrument.ActualArrivalDate == null) {
          that.$message.error(`请填写${instrument.InstrumentName}的实际到货日期`)
          flag = false
          return false
        }

        if (instrument.ArrivalAddress[0] == '' || instrument.ArrivalAddress[0] == null) {
          that.$message.error(`请填写${instrument.InstrumentName}的实际设备到货地`)
          flag = false
          return false
        }
        if (instrument.ConfirmAttach.length == 0) {
          that.$message.error(`请上传${instrument.InstrumentName}的到货确认函附件`)
          flag = false
          return false
        }
        if (instrument.ConfirmOtherAttach2.length == 0) {
          that.$message.error(`请上传${instrument.InstrumentName}的说明书附件`)
          flag = false
          return false
        }
      })
      if (flag) {
        this.postRequest('/Contract/SaveArrivalConfirm', {
          contractId: this.contractId,
          projectListJson: JSON.stringify(selectProjectList)
        }).then((res) => {
          if (res.data.errcode == 0) {
            this.$message.success('提交成功')
            window.close()
          } else {
            this.$message.error(res.data.errmsg)
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.fileName {
  cursor: pointer;
  white-space: nowrap;
  width: 80%;
  text-overflow: ellipsis;
  overflow: hidden;
  display: inline-block;
  color: #0066cc;
}

.content_wrap {
  padding-bottom: 20px;
  margin-bottom: 20px;
}

.changeInform_btn_wrap {
  width: 366px;
  margin: 40px auto 0;

  .btn_1 {
    background: #055ba9;
    color: #fff;
    border: none;
  }
}

.supplierType {
  .el-form-item {
    display: inline-block;
    flex: 0 0 200px;

    .el-input {
      width: 200px;
    }
  }

  .supplierOtherType {
    ::v-deep.el-form-item__content {
      border-bottom: none;
    }
  }
}

::v-deep.businessTermDate {
  .el-form-item__content {
    align-items: center;
  }

  .term {
    margin-top: 0 !important;
    margin-left: 0 !important;
  }

  .el-input {
    width: 300px;
    margin-right: 8px;
  }

  .businessTermEndDate {
    margin-bottom: 0 !important;

    .el-input {
      width: 100% !important;
    }

    .el-form-item__label:before {
      display: none;
    }

    .el-form-item__content {
      border-bottom: none;
    }
  }
}

::v-deep.el-form-item {
  .el-input.is-disabled .el-input__inner,
  .el-select .el-input.is-disabled .el-input__inner,
  .el-checkbox__input.is-disabled + span.el-checkbox__label,
  .el-textarea.is-disabled .el-textarea__inner {
    color: #606266;
  }
}

.back_btn {
  height: 26px;
  bottom: 7px;
  padding: 0 18px;
  border-radius: 14px;
}

.businessTermDate1 ::v-deep.el-input__inner {
  min-width: 150px !important;
}

.tableWrap5_custom ::v-deep.btn_wrap {
  margin-right: 12px;
  margin-top: 15px;
}

.tableWrap5_custom ::v-deep.tab_wrap5 {
  margin: 0 15px 15px;

  .product_form {
    margin-bottom: 0;
  }
}

.change_inform ::v-deep.icon_tips2 {
  vertical-align: middle !important;
}

.rangeDate ::v-deep.el-form-item__content {
  .el-input__inner,
  .el-range-editor {
    width: 300px;
    margin-right: 8px;
    text-align: center;

    .el-range-input {
      font-size: 14px;
    }
  }
}

.tree ::v-deep .el-tree-node {
  .el-tree-node__children {
    white-space: normal;

    .el-tree-node {
      display: inline-block;
    }
  }
}

.otherinput {
  height: 25px;
  line-height: 40px;
  width: 100%;
}

.width_full {
  width: 100% !important;
}

.statistics_table {
  width: 98.5%;
  table-layout: fixed;

  th {
    padding: 6px 0;
    text-align: center !important;
    background: #d8eafa !important;
    color: #046663;
    font-weight: normal !important;
    border: 1px solid #95c7f0;
    vertical-align: middle;
    white-space: nowrap;
  }

  td {
    padding: 6px 12px;
    border: 1px solid #95c7f0;
    background: #fff !important;
    text-align: center;
  }

  tr {
    border-bottom: 1px solid #95c7f0;
  }
}

.file_wrap {
  width: 18rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.form_table1 {
  .el-form-item {
    flex: 33.3%;
  }
}
.start {
  vertical-align: middle;
  color: #f56c6c;
  display: inline-block;
  margin-right: 4px;
}
</style>